// @flow

import queryString from 'query-string';
import { get, isEmpty } from 'lodash';

import { serviceImageSizes } from 'web-ssr/app/services/constants';

import type { ServiceAction } from 'web-ssr/app/model/ServiceAction';
import type { ServiceActionDropdownItem } from 'web-ssr/app/viewModel/ServiceActionDropdownItem';
import type { ServiceActionMap } from 'web-ssr/app/model/ServiceActionMap';
import type { ServiceImageSize } from 'web-ssr/app/services/types';
import type { ServiceImages } from 'web-ssr/app/model/ServiceImages';

export const stripBuiltInName = (str: ?string): string =>
  str ? str.replace(' by Zapier', '') : '';

export const filterHiddenActions = (actions: ?(ServiceAction[])) => {
  if (!actions) {
    return [];
  }

  return actions.filter(action => !action.hide);
};

export const buildMakeAZapLink = (
  selectedTrigger: ServiceActionDropdownItem,
  selectedAction: ServiceActionDropdownItem
) => {
  const qs = queryString.stringify({
    template__0__selected_api: get(selectedTrigger, ['serviceId']),
    template__0__type_of: get(selectedTrigger, ['typeOf']),
    template__0__action: get(selectedTrigger, ['value']),
    template__1__selected_api: get(selectedAction, ['serviceId']),
    template__1__type_of: get(selectedAction, ['typeOf']),
    template__1__action: get(selectedAction, ['value']),
    create: true,
  });

  return `/app/editor/?${qs}`;
};

export const canCreateZapFromIntegrations = (
  primaryActions?: ?ServiceActionMap,
  secondaryActions?: ?ServiceActionMap
) => {
  const triggers = filterHiddenActions([
    ...get(primaryActions, 'reads', []),
    ...get(secondaryActions, 'reads', []),
  ]);
  const actions = filterHiddenActions([
    ...get(primaryActions, 'writes', []),
    ...get(secondaryActions, 'writes', []),
  ]);

  return !isEmpty(triggers) && !isEmpty(actions);
};

export const getServiceImageBySize = (
  size: ServiceImageSize,
  imageMap: ?ServiceImages
) => {
  if (!imageMap) {
    return undefined;
  }

  const imageSize = serviceImageSizes[size];

  return imageMap[imageSize];
};

export const createZapLink = (
  primaryServiceId: string,
  secondaryServiceId?: ?string
) => {
  return `/zapbook/create/${primaryServiceId}${
    secondaryServiceId ? `/${secondaryServiceId}` : ''
  }`;
};

export const createTrackedLink = (url: ?string) => {
  return isEmpty(url)
    ? null
    : `${url}?utm_source=zapier.com&utm_medium=referral&utm_campaign=zapier`;
};
